const e = {
  id: "ArizonaThePick",
  name: "The Pick",
  style: {
    colorPrimary: "#004785"
  }
};
export {
  e as default
};
